import React from "react";
import styles from "../styles/evento-form.module.css";


export function Stepper({ steps, step, onStepChange }) {
    const total = Math.max(steps.length - 1, 1);
    const pct = (step / total) * 100;

    return (
        <div className={styles.stepperWrap}>
            <div className={styles.stepper}>
                {steps.map((label, idx) => {
                    const isActive = idx === step;
                    const isDone = idx < step;

                    const cls = [
                        styles.stepBtn,          // base: igual que tabs
                        isActive ? styles.primary : styles.ghost, // variante: igual que tabs
                        isDone ? styles.stepDone : "",
                    ].join(" ");

                    return (
                        <button
                            key={`${label}-${idx}`}
                            type="button"
                            className={cls}
                            onClick={() => onStepChange(idx)}
                        >
                            <span className={styles.stepDot}>{idx + 1}</span>
                            <span className={styles.stepText}>{label}</span>
                        </button>
                    );
                })}
            </div>

            <div className={styles.stepperTrack} aria-hidden="true">
                <div className={styles.stepperProgress} style={{ width: `${pct}%` }} />
            </div>
        </div>
    );
}

